(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name documentManager.controller:DocumentManagerCtrl
	 *
	 * @description
	 *
	 */
	angular.module('documentManager').directive('focusOn', function($timeout) {
		return {
			restrict : 'A',
			link : function(vm, $element, $attr) {
				vm.$watch($attr.focusOn, function(_focusVal) {
					$timeout(function() {
						_focusVal ? $element[0].focus() : $element[0].blur();
					});
				});
			}
		}
	}).controller('DocumentManagerCtrl', DocumentManagerCtrl);

	function DocumentManagerCtrl(MessageService, CommonMasterData,
			applicationConstants, DocumentManagerService, PopupManager,
			$window, $timeout, EventManagerService, $sce) {
		
		var vm = this;
		vm.ctrlName = 'DocumentManagerCtrl';
		var newDoc = null, crewArrayByType = {}, newRequestOnly = false;
		var testArrary = [];
		
		vm.model = {
			searchPanelToggle : true,
			initialSearchDone : false,
			searchCriteria : null,
			masterList : {
				crewTypeList : [],
				categoryList : [],
				crewList : []
			},
			documentList : [],
			selectedDocument : null,
			recordChange : false,
			isElasticLoadingVisible : false
		};

		EventManagerService.registerEventListener(
				EventManagerService.EVENT.DOCUMENT_MANAGER.FILL_CREW_BY_TYPE,
				getUpdateCrewByType);

		vm.maxHeight = window.innerHeight - (70 + 42 + 40 + 80);

		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
		};

		vm.clickAddNewDocument = function() {			
			var _foundActive = getActiveItem();
			if (!!_foundActive) {
				_foundActive.activeFlag = false;
				if (_foundActive.actionFlag) {
					_foundActive.actionFlag = false;
				}
			}
			newDoc = DocumentManagerService.getDocDisplayInGrid();
			var editOptions = DocumentManagerService.getDocumentEditOptions(
					null, 'ADD', newDoc, vm.model.masterList, onSubmitCallBack,
					onFieldChangeCallBack);
			newDoc.inlineEditOptions = editOptions;
			newDoc.actionFlag = true;
			vm.model.documentList.unshift(newDoc);
			vm.model.selectedDocument = newDoc;
			vm.model.recordChange = true;
			vm.model.searchPanelToggle = false;
		};

		vm.submitSearchDocuments = function(searchParams) {
			vm.model.documentList = [];
			vm.model.initialSearchDone = true;
			DocumentManagerService.setSearchCriteria(searchParams);
			searchDocument();
		};

		vm.selectDocument = function(selectedDoc, flag) {
			
			setSelectedRowAsActiveRow(selectedDoc);
			
			if (flag.toUpperCase() === 'EDIT') {
				
				selectedDoc.actionFlag = true;
				vm.model.recordChange = true;
				vm.model.selectedDocument = selectedDoc;
				viewDocument();
				
			} else if (flag.toUpperCase() === 'CLOSE') {
				
				discardUnsavedChanges(selectedDoc);
				
			} else if (flag.toUpperCase() === 'ROW') {
				
				if (vm.model.selectedDocument == null
						|| (!!vm.model.selectedDocument && !!selectedDoc.downloadId && vm.model.selectedDocument.downloadId != selectedDoc.downloadId)) {
					var unsavedChange = isUnsavedChangesExist();

					if (unsavedChange > -1) {
						discardUnsavedChanges(unsavedChange);
					} else {
						vm.model.selectedDocument = selectedDoc;
						viewDocument();
					}
				}
			}
		};
		
		function setSelectedRowAsActiveRow(selectedDoc){
			var _foundActive = getActiveItem();
			if (!!_foundActive) {
				_foundActive.activeFlag = false;
				if (_foundActive.actionFlag
						&& (selectedDoc.downloadId !== _foundActive.downloadId)) {
					_foundActive.actionFlag = false;
				}
			}
			
			selectedDoc.activeFlag = true;
		}

		vm.fileChange = function() {

		};

		vm.downloadDocument = function() {
			vm.model.selectedDocument = DocumentManagerService
					.setSelectedDocInView();
		};

		function isUnsavedChangesExist() {
			return _.findIndex(vm.model.documentList, {
				'downloadId' : null
			});
		}

		function discardUnsavedChanges(selectedDoc) {
			if (selectedDoc.downloadId == null) {
				displayConfirmation();
			} else {
				selectedDoc.actionFlag = false;
				selectedDoc.activeFlag = true;
				vm.model.selectedDocument.viewUrl = $sce.trustAsResourceUrl('');
			}
		}

		function viewDocument() {

			if (vm.model.selectedDocument.downloadId != null) {

				DocumentManagerService.getDownloadDocument(
						vm.model.selectedDocument, function(response, status,
								headers, config) {
							vm.model.selectedDocument = DocumentManagerService
									.setSelectedDocInView(response,
											vm.model.selectedDocument);
						}, function(error) {
							MessageService.error("Document is not available to view");
						});

			}
		}

		function getActiveItem() {
			var _foundActive = _.find(vm.model.documentList, {
				'activeFlag' : true
			});
			if (angular.isUndefined(_foundActive)) {
				_foundActive = null;
			}
			return _foundActive
		}

		function displayConfirmation() {
			if (vm.model.recordChange) {
				var details = {
					title : 'Confirmation',
					messages : [ 'Unsaved data will be deleted. \n Do you want to Proceed?' ]
				};
				PopupManager.openModal('CONFIRM_DIALOG', details,
						confirmUnSavedData);
			}
		}

		//Edit options call backs

		function onSubmitCallBack(action, selectedItem, formFiles) {
			if (action.toUpperCase() === 'DELETE') {
				deleteDocument(formFiles, selectedItem)
			} else {
				saveDocument(formFiles, selectedItem)
			}
		}

		function searchDocument() {
			var params = DocumentManagerService.getSearchCriteria();
			params.startPosition = 1;
			params.pageSize = 30;
			DocumentManagerService.searchDocuments(params, function(docList) {
				updateDocumentList(docList);
				vm.model.searchPanelToggle = false;
			}, function(error) {
				MessageService.error(error);
			})
		}

		function deleteDocument(formFiles, selectedItem) {
			DocumentManagerService
					.deleteDocument(
							formFiles,
							selectedItem,
							function(response) {
								if (response.success) {
									vm.model.documentList = [];
									vm.model.selectedDocument = null;
									searchDocument();
									MessageService
											.success(MessageService.MESSAGES.DOCUMENT_MANAGER.DELETE_SUCCESS);
								}
							}, function(error) {
								MessageService.error(error);
							});
		}

		function saveDocument(formFiles, selectedItem) {
			DocumentManagerService
					.submitDocumentForm(
							formFiles,
							selectedItem,
							function(response) {
								if (response.success) {
									vm.model.documentList = [];
									vm.model.selectedDocument = null;
									searchDocument();
									MessageService
											.success(MessageService.MESSAGES.DOCUMENT_MANAGER.SUCCESS_SAVE);
								}
							}, function(error) {
								MessageService.error(error.error);
							});
		}

		function onFieldChangeCallBack(flag, operation, selectedItems) {
			if (flag == 'crewType') {
				vm.model.masterList.crewList = [];
				for (var i = 0; i < selectedItems.length; i++) {
					var crewType = selectedItems[i].crewTypeCode;
					vm.model.masterList.crewList = vm.model.masterList.crewList
							.concat(getCrewsByType(crewType));
				}
			}
			if (flag == 'selectedCrew') {

			}
		}

		function getCrewsByType(crewType) {
			return crewArrayByType[crewType].availCrew;
		}

		function getCrewByTypeAndUpdate(crewType) {
			CommonMasterData
					.loadCrewList(
							{
								crewType : crewType
							},
							function(crewList) {
								crewArrayByType[crewType].updated = true;
								crewArrayByType[crewType].availCrew = DocumentManagerService
										.getFromatedCrewList(crewList);
								EventManagerService
										.notifyEventListeners(EventManagerService.EVENT.DOCUMENT_MANAGER.FILL_CREW_BY_TYPE);
							}, function(error) {
							});
		}

		function getUpdateCrewByType() {
			for ( var crewType in crewArrayByType) {
				if (!crewArrayByType[crewType].updated) {
					getCrewByTypeAndUpdate(crewType);
					crewArrayByType[crewType].updated = true;
					break;
				}
			}
		}

		function updateDocumentList(doclists) {
			_.each(doclists, function(doc) {
				var newDoc = DocumentManagerService.getDocDisplayInGrid(doc);
				var masterList = angular.copy(vm.model.masterList);
				var crewListArr = [];
				angular.forEach(newDoc.crewType, function(crewType) {
					crewListArr = crewListArr
							.concat(getCrewsByType(crewType.crewTypeCode));
				});
				masterList.crewList = crewListArr;
				var editOptions = DocumentManagerService
						.getDocumentEditOptions(null, 'ADD', newDoc,
								masterList, onSubmitCallBack,
								onFieldChangeCallBack);
				newDoc.inlineEditOptions = editOptions;
				newDoc.actionFlag = false;
				vm.model.documentList.push(newDoc);
			});
		}

		function confirmUnSavedData(pass) {
			if (pass == 'YES') {
				findAndRemoveFromDocList();
			}
		}

		function findAndRemoveFromDocList() {
			var _found = _.findIndex(vm.model.documentList, {
				'downloadId' : null
			});
			if (_found > -1) {
				vm.model.documentList.splice(_found, 1);
			}
		}

		function createCrewByTypeArray() {
			crewArrayByType = {};
			angular.forEach(vm.model.masterList.crewTypeList,
					function(crewType) {
						crewArrayByType[crewType.crewTypeCode] = {
							availCrew : [],
							updated : false
						};
					});
		}

		angular.element($window).bind('resize', function() {
			$timeout(function() {
				vm.maxHeight = window.innerHeight - (70 + 42 + 40 + 80);
			}, 0);
		});

		(function() {
			vm.model.searchCriteria = DocumentManagerService
					.getSearchCriteria();
			vm.model.masterList.crewList = [];
			CommonMasterData.getCrewTypeList(function(crewTypes) {
				vm.model.masterList.crewTypeList = crewTypes;
				createCrewByTypeArray();
				getUpdateCrewByType();
			}, function(error) {
			});
			CommonMasterData.getDownloadCategoryList(function(
					downloadCategories) {
				vm.model.masterList.categoryList = downloadCategories;
			}, function(error) {
			});
		})()
	}
}());
